export const state = () => ({
  project: {
    tasks_count: 0
  },
  profileGroupCategories: [],
  profileGroupCategoriesSlug: null,
  profileGroupCategoriesLoading: false
});

export const getters = {
  project: state => state.project,
  profileGroupCategories: state => state.profileGroupCategories
};

export const mutations = {
  SET_PROJECT(state, project) {
    state.project = project;
  },

  CLEAR_PROJECT(state) {
    state.project = {};
  },

  SET_PROFILE_GROUP_CATEGORIES(state, payload) {
    state.profileGroupCategories = payload;
  },

  SET_PROFILE_GROUP_CATEGORIES_LOADING(state, payload) {
    state.profileGroupCategoriesLoading = payload;
  },

  SET_PROFILE_GROUP_CATEGORIES_SLUG(state, payload) {
    state.profileGroupCategoriesSlug = payload;
  },

  ADD_PROFILE_GROUP_CATEGORY(state, payload) {
    state.profileGroupCategories.push(payload);
  },
};
